import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Input from "./common/input";
import http from "../services/http";

const ResetForm = ({ match, history }) => {
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  useEffect(() => {
    async function validateToken() {
      try {
        await http.get(`/user-reset/${match.params.id}`);
      } catch (error) {
        history.push("/login");
        toast.error("Invalid link");
      }
    }
    if (match.params.id) {
      validateToken();
    }
  }, [match.params.id, history]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (newPassword !== repeatPassword)
      return toast.error("Passwords must match");

    try {
      await http.post(`/user-reset/reset/${match.params.id}`, {
        newPassword,
      });
      toast.success("Password Updated");
      history.push("/login");
    } catch (ex) {
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  return (
    <div className="container">
      <div className="row justify-content-center mt-5">
        <div className="col-6">
          <h1 className="display-4 text-center">Reset Your Password</h1>
          <p className="lead">Please enter a new password for your account</p>
          <p className="lead">
            Password must be a minimum of 14 characters and have 3 of the
            following: Lowercase, Uppercase, Number and Symbol
          </p>
        </div>
      </div>
      <form>
        <Input
          name="new-password"
          type="password"
          label="New Password"
          placeholder="Password"
          error=""
          value={newPassword}
          onChange={(e) => setNewPassword(e.currentTarget.value)}
        />
        <Input
          name="repeat-password"
          type="password"
          label="Repeat New Password"
          placeholder="Password"
          error=""
          value={repeatPassword}
          onChange={(e) => setRepeatPassword(e.currentTarget.value)}
        />
        <button className="btn btn-success" onClick={handleSubmit}>
          Reset
        </button>
      </form>
    </div>
  );
};

export default ResetForm;
